import { ActionBase } from "../action";
import { ImageEditor } from "../imageeditor";
import { ToolBase } from "../tool";

export class ToolbarItem {

  /**
   * @type {HTMLElement}
   */
  element = null

  /**
   * @type {string}
   */
  name = null

  /**
   * @type {ImageEditor}
   */
  imageEditor = null;

  /**
   * @type {ToolBase}
   */
  tool = null

  /**
   * @type {ActionBase}
   */
  action = null

  /**
   * @type {Boolean}
   */
  isActive = false;

  /**
   * @type {Function}
   */
  onClickCallback = null;

  /**
   * Constructeur
   * @param {HTMLElement|String} element 
   * @param {ToolBase} tool 
   */
  constructor(imageEditor, name, element) {
    if(imageEditor == null) return;
    this.name = name;

    if (element instanceof HTMLElement) {
      this.element = element;
    } else {
      this.element = document.querySelector(element);
    }

    this.imageEditor = imageEditor;

    this.element.addEventListener("click", (evt) => {
      this.onClick();
      if(this.tool != null) {
        this.setActive(true)
      } else if(this.action != null) {
        this.action.performAction();
      }
    })
  }

  /**
   * Set if the toolbar item is active.
   * @param {Boolean} value 
   */
  setActive(value) {
    if(this.tool == null) return;

    this.isActive = value;

    if(value){
      for (const item of this.imageEditor.toolbar.items) {
        if(item.tool != null) {
          item.setActive(false)
        }
      }
  
      for (const tool of this.imageEditor.tools) {
        if(tool != null) {
          tool.setActive(false)
        }
      }
    }

    if(value){
      this.element.classList.add("active");
    } else {
      this.element.classList.remove("active");
    }

    this.tool.setActive(value)
  }

  onClick() {
    if(this.onClickCallback != null){
      this.onClickCallback(this.imageEditor);
    }
  }

}